import { K8sProviderIcon } from '@cast/features-cluster-ui';
import { useContext } from 'react';

import {
  Button,
  DialogActions,
  Divider,
  ScrollableDialogContent,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsFeaturesComplete } from '../../../../_components/AssignCredentialsFeaturesComplete';
import {
  ClusterDialogTitle,
  DialogHeading,
  StepContainer,
} from '../../../../_components/new-onboarding';
import { OnboardClusterContext } from '../../../OnboardClusterProvider';

type Props = {
  onDone: () => void;
  onClose: () => void;
};

export const SuccessStep = ({ onDone, onClose }: Props) => {
  const { featureSelection, provider } = useContext(OnboardClusterContext);

  return (
    <StepContainer data-testid="success-step">
      <DialogHeading onClose={onClose} hideTerraformLink>
        <Stack direction="row" alignItems="center" gap={8} flexWrap="nowrap">
          <K8sProviderIcon provider={provider} size={24} />
          <ClusterDialogTitle>Cluster connected</ClusterDialogTitle>
        </Stack>
      </DialogHeading>

      <ScrollableDialogContent>
        <Stack pt={20}>
          <Typography
            variant="L10M"
            color={colorOrToken(
              'grey.400',
              tokens.theme.fg.structural.secondary
            )}
            mb={8}
          >
            Enabled features:
          </Typography>
          <AssignCredentialsFeaturesComplete
            enabledFeatures={featureSelection}
          />
        </Stack>
      </ScrollableDialogContent>
      <Divider
        color={colorOrToken(
          'grey.100',
          tokens.theme.border.structural.neutralSubtle
        )}
      />
      <DialogActions>
        <Button onClick={onDone} testId="done-button">
          Done
        </Button>
      </DialogActions>
    </StepContainer>
  );
};
